const quotesColumns = [
  // {
  //   key: 'sampleImages',
  //   label: 'Sample images'
  // },
  {
    key: 'variant',
    label: 'Type'
  },
  {
    key: 'price',
    label: 'Production Unit Cost'
  },
  {
    key: 'quantity',
    label: 'Quantity'
  },
  {
    key: 'supplier_name',
    label: 'Supplier'
  },
  {
    key: 'match_score',
    label: 'Match'
  },
  {
    key: 'ui_status',
    label: 'Status'
  },
  {
    key: 'updated_at',
    label: 'Updated'
  },
  {
    key: 'supplier_factory_country',
    label: 'Origin'
  }
];

export default quotesColumns;
